import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import dayjs from 'dayjs';
import { CircularProgress } from '@mui/material';

import Text from '../../../../../../shared/uiComponents/Text';

import { DispatchProperties, useSelector } from '../../../../../../redux/store';
import { getTargetHistory } from '../../../../../../redux/State/clientSlice/programTargetSlice';
import { EditedTargetIcon, HoldIcon, PlayIcon } from '../../../../../../shared/Assets/svg';

const TargetHistory = ({ id, programId }: { id: string; programId: string }) => {
	const dispatch = useDispatch<DispatchProperties>();

	const history = useSelector((state) => state.programTarget.history);
	const loading = useSelector((state) => state.programTarget.loadingHistory);

	useEffect(() => {
		if (!id || !programId) return;
		dispatch(getTargetHistory({ id, programId }));
	}, [id, programId, dispatch]);

	return (
		<div>
			<Text title="History" type="h6" font="header" fontWeight="semiBold" className="marginBottom8" />
			{!loading &&
				Boolean(history) &&
				history.map((item, index) => {
					const time = dayjs(item.madeAt).format('MM/DD/YYYY • hh:mm:ss A');

					const getIcon = () => {
						const message = item.message.toLowerCase();
						if (message.includes('hold')) return <HoldIcon size={52} />;
						if (message.includes('opened')) return <PlayIcon size={52} />;
						if (message.includes('edited')) return <EditedTargetIcon size={52} />;
						if (message.includes('closed')) return <HoldIcon size={52} />;

						return <HoldIcon size={52} />;
					};

					return (
						<div key={index} className="targetHistoryRow">
							<div className="targetHistoryTimeline">
								{getIcon()}
								<div className="targetHistoryLine" />
							</div>
							<div className="targetHistoryItem">
								<Text title={time} type="psm" color="secondary" />
								<Text title={item.message} />
							</div>
						</div>
					);
				})}
			{loading && (
				<div style={{ width: 'max-content', margin: 'auto' }}>
					<CircularProgress color="inherit" />
				</div>
			)}
		</div>
	);
};

export default TargetHistory;
